import React, { useState, useCallback } from 'react';

import { Button, Typography, Space, Popconfirm, Divider } from 'antd';
import MerchantMenuSelector from 'menuManagement/MerchantMenuSelector';
import ResponseModal from 'menuManagement/ResponseModal';
import propTypes from 'prop-types';

import { clearCustomTaxes } from 'menuManagement/MenuManagementHelpers';

const { Text } = Typography;

ClearCustomTaxes.propTypes = {
	merchantId: propTypes.string.isRequired,
	companyId: propTypes.string.isRequired,
};

export default function ClearCustomTaxes({ merchantId, companyId }) {
	const [responseModalVisible, setResponseModalVisible] = useState(false);
	const [response, setResponse] = useState({});
	const [menuSelectValue, setMenuSelectValue] = useState('');

	const onConfirm = useCallback(async () => {
		try {
			const menuManagementResponse = await clearCustomTaxes(
				companyId,
				merchantId,
				menuSelectValue,
			);
			setResponse(menuManagementResponse);
			setResponseModalVisible(true);
		} catch (e) {
			console.error(`Exception while clearing custom taxes - ${e}`);
			setResponse({ error: 'Exception while clearing custom taxes' });
			setResponseModalVisible(true);
		}
	}, [
		setResponse,
		setResponseModalVisible,
		companyId,
		merchantId,
		menuSelectValue,
	]);

	return (
		<Space direction="vertical" size="small" style={{ width: 600 }}>
			<Text>
				Select a menu to clear all custom tax rates from. This action cannot be
				undone.
			</Text>
			<Divider />
			<Text>Menu</Text>
			<MerchantMenuSelector
				setMenuSelectValue={setMenuSelectValue}
				merchantId={merchantId}
				selectType="single"
			/>
			<Popconfirm
				title="This will remove all custom tax rates from this menu. Are you sure?"
				onConfirm={onConfirm}
				okText="Clear Taxes"
				cancelText="Cancel"
			>
				<Button type="primary" disabled={!menuSelectValue}>
					Clear Taxes
				</Button>
			</Popconfirm>
			<ResponseModal
				title="Clear Custom Taxes Result"
				response={response}
				responseModalVisible={responseModalVisible}
				setResponseModalVisible={setResponseModalVisible}
			/>
		</Space>
	);
}
